import {PageContent, UploadMedia, DisplayContentTab} from '@/components/organisms'
import {PageHeader} from '@/components/molecules'
import PropTypes from 'prop-types'
import {Tab, TabsNavigation} from '@/components/atoms'
import {Constants} from '@/utils/constants/commonConstants'

const DisplayContent = ({
  displayContentFormData,
  setDisplayContentFormData,
  mediaCardFormData,
  setMediaCardFormData,
  languages,
  handleTabClick,
  activeLanguage,
  targetType,
}) => {
  return (
    <>
      <PageContent className="sales-target-component bg-neutral-800 text-white" pageContentWrapperClassName="relative">
        <div className="flex items-center justify-between">
          <PageHeader title={'Display Content'} />
        </div>
        <TabsNavigation
          className="display-content-nav mb-6 w-full border-b border-gray-700"
          activeTabIndex={0}
          handleSetActiveTab={function Qa() {}}
        >
          {languages &&
            languages?.length > 0 &&
            languages.map((lang, idx) => (
              <Tab
                key={`${idx}_${lang.code}`}
                label={lang.title}
                className="no-icon"
                onClick={() => handleTabClick(lang.code)}
                isDark
              />
            ))}
        </TabsNavigation>

        <DisplayContentTab
          displayContentFormData={displayContentFormData}
          setDisplayContentFormData={setDisplayContentFormData}
          activeLanguage={activeLanguage}
          languages={languages}
          targetType={targetType}
        />
      </PageContent>
      <PageContent className="sales-target-component bg-neutral-800 text-white" pageContentWrapperClassName="relative">
        <UploadMedia
          mediaCardFormData={mediaCardFormData}
          setMediaCardFormData={setMediaCardFormData}
          uploadFor={Constants.SalesTargetMedia}
        />
      </PageContent>
    </>
  )
}

DisplayContent.propTypes = {
  displayContentFormData: PropTypes.shape({
    newDisplayTitle: PropTypes.string.isRequired,
    parentCategory: PropTypes.string,
    childCategory: PropTypes.string,
    exerpt: PropTypes.string,
    terms: PropTypes.string,
    targetType: PropTypes.string,
  }).isRequired,
  setDisplayContentFormData: PropTypes.func.isRequired,
  mediaCardFormData: PropTypes.shape({
    title: PropTypes.string.isRequired,
    imageId: PropTypes.string,
    optIn: PropTypes.bool,
  }).isRequired,
  setMediaCardFormData: PropTypes.func.isRequired,
  handleTabClick: PropTypes.func.isRequired,
  languages: PropTypes.arrayOf(
    PropTypes.shape({
      languageId: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      code: PropTypes.string.isRequired,
    })
  ).isRequired,
}

export default DisplayContent
